import { InstrumentBrand } from '@foundation/apis/payments';
import { useTranslation } from '@shared/localization';

export const useUserFriendlyPrefixForInstrumentBrand = () => {
  const { t } = useTranslation();

  return (brand: InstrumentBrand) => {
    switch (brand) {
      case InstrumentBrand.Amex:
        return 'Amex';
      case InstrumentBrand.Diners:
        return 'Diners';
      case InstrumentBrand.Discover:
        return 'Discover';
      case InstrumentBrand.Elo:
        return 'Elo';
      case InstrumentBrand.Jcb:
        return 'Jcb';
      case InstrumentBrand.Maestro:
        return 'Maestro';
      case InstrumentBrand.MasterCard:
        return 'Mastercard';
      case InstrumentBrand.DirectDebit:
        return t('Direct debit');
      case InstrumentBrand.UnionPay:
        return 'UPay';
      case InstrumentBrand.Visa:
        return 'Visa';
      case InstrumentBrand.DirectDebitPostFinance:
        return 'PostFinance';
      case InstrumentBrand.DirectDebitLSV:
        return 'LSV+';
      default:
        return undefined;
    }
  };
};
